import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/Help-Desk-Components/Footer/Footer";
import HeaderBuga from "../../components/header6/Header6";

const ComplaintPolicy = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };
  return (
    <Fragment>
      <div className="body_wrap sco_agency">
        <HeaderBuga />
        <section
          className="page-title pt-100  pos-rel bg_img breadcrums-bgr"
          //   style={{ backgroundImage: `url(${Bg})` }}
        >
          <div className="container">
            <div className="page-title-wrap">
              <div className="row mt-none-30 align-items-center text-center">
                <div className="col-xl-12 col-lg-8 mt-30">
                  <div className="page-title-box">
                    <h2 className="title">
                      Complaint Policy
                      <br />
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="terms&conditions-section cp-det-bg">
          <div className="container">
            <div className="terms-section_inner pt-80 pb-75">
              <div className="row">
                <div className="privacy-policy-content">
                  <h2 class="item_details_info_title">Our complaint policy</h2>
                  <p>
                    We are committed to providing a high-quality money transfer
                    service to all our clients. When something goes wrong, we
                    need you to tell us about it. This will help us to improve
                    our standards.
                  </p>
                  <p>
                    If you have a complaint, please contact us with the details.
                  </p>
                  {/*<h3>Definitions</h3>*/}
                  <ul className="lower-alpha-list">
                    <li>
                      By Email:{" "}
                      <a href="mailto:info@bugamoney.com">info@bugamoney.com</a>
                    </li>
                    <li>
                      By Phone: <a href="tel:+447459852485">+44 745 985 2485</a>
                    </li>
                    <li>
                      By Post: 175 Roding Lane North, Woodford Green, England, IG8 8NA
                    </li>
                    <li>
                      Walk-in: 175 Roding Lane North, Woodford Green, England, IG8 8NA
                    </li>
                  </ul>
                  <h2 class="item_details_info_title">
                    What will happen next?
                  </h2>
                  <ul className="lower-alpha-list">
                    <li>
                      We will send you a letter/email acknowledging receipt of
                      your complaint on the same day of receiving it, enclosing
                      a copy of this procedure. If you have complained in person
                      or on call, we will try to resolve and reach resolution
                      the same day.
                    </li>
                    <li>
                      If we are unable to resolve your complaint on the same
                      day, then we will further investigate your complaint. This
                      will normally involve finding details of your complaint,
                      reviewing your matter by speaking to the member of staff
                      who interacted with you.
                    </li>
                    <li>
                      We will respond to you within 15 days or in 35 day in
                      exceptional circumstances with our Final Response which
                      may be a redress offer or remedial action.
                    </li>
                    <li>
                      If you are still not satisfied, you can then contact the
                      Financial Ombudsman Service, about your complaint.
                      Normally, you will need to bring a complaint to the
                      Financial Ombudsman Service within six months of receiving
                      a final written response from us about your complaint. For
                      further information, you should contact the Financial
                      Ombudsman Service on:
                      <ul className="lower-roman-list">
                        <li>
                          Online:{" "}
                          <a
                            href="https://www.financial-ombudsman.org.uk/"
                            target="_blank"
                          >
                            https://www.financial-ombudsman.org.uk/
                          </a>
                        </li>
                        <li>
                          Email:{" "}
                          <a href="mailto: complaint.info@financial-ombudsman.org.uk">
                            complaint.info@financial-ombudsman.org.uk
                          </a>{" "}
                          ,
                        </li>
                        <li>
                          Mail: The Financial Ombudsman Service Exchange Tower,
                          London, E14 9SR
                        </li>
                        <li>
                          Phone: <a href="tel:08000234567">0800 023 4567 </a>
                          (free),{" "}
                          <a className="a" href="tel:03001239123">
                            0300 123 9123
                          </a>
                          , weekdays from 8:00am - 5:00pm (GMT), and on Saturday
                          from 9:00am - 1pm (GMT).
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <p>
                    FOS will not charge you any fee for making a complaint and
                    if you are not satisfied with the outcome you can still
                    bring legal proceedings. In addition, please note that
                    disputes may also be submitted for online resolution via the
                    European Online Dispute Resolution Platform accessible at:{" "}
                    <a href="http://ec.europa.eu/odr" className="custom-link" target="_blank">
                      http://ec.europa.eu/odr
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default ComplaintPolicy;
